exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-1faf3ac2]:nth-child(2n){background-color:#f4f5f7}.filter-select[data-v-1faf3ac2]{max-width:120px}", ""]);

// exports
